import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UsuariosService } from '../usuarios/usuarios.service';
import {catchError, finalize, Observable, tap, throwError} from 'rxjs';
import { NgxSpinnerService } from 'ngx-spinner';
import { UtilsService } from '../utils/utils.service';

@Injectable({
  providedIn: 'root'
})
export class AuthInterceptorService implements HttpInterceptor {

  constructor(
    private _usuarios: UsuariosService,
    private spinner: NgxSpinnerService,
    private _utils: UtilsService
  ) { }
  private totalRequests = 0
  private arrServicesToExclude = [
    '/registro-calificacion/crearRegistroCalificacion',
    '/corporativo/asignaturas',
    '/docente/obtenerSecciones',
    '/docente/obtenerDocentes',
    '/obtenerListaUsuario',
    '/reporte-calificacion/buscaListadoReportes',
    '/reporte-estado-seccion/obtener-listado'
  ]
  private arrServicesExcludeModalErr = [
    '/cargarArchivo',
    '/alineacion/crear',
    '/alineacion/docente/confirmar'
  ]

  fnRequest(request: any): any {
    const token = this._usuarios.getToken()
    if (token) {
      request = request.clone({
        setHeaders: {
          authorization: `Bearer ${token}`
        }
      });
    }
    return request
  }

  fnCatchError(err: any, trimmedUrl: any): void {
    if (err instanceof HttpErrorResponse) {
      if (err.status === 401 || err.status === 403) {
        localStorage.clear()
        if (trimmedUrl === '/perfilamiento') {
          window.location.href = "/sin-acceso"
        } else {
          window.location.href = "/login"
        }
      } 
      if ( err.status !== 406 && (err.status !== 401 && err.status !== 403) ) {
        if ( !this.arrServicesExcludeModalErr.includes(trimmedUrl) ) {
          // Mostrar modal estandar
          this._utils.asyncModalServiceError({
            mensaje: err?.error?.details?.[0] ?? '<b>Parece que algo no salió como esperábamos…</b><br>Es posible que haya ocurrido un error en nuestra plataforma o que tu conexión a internet esté fallando. <br>Te sugerimos revisar tu conexión y, si todo parece estar bien, intenta nuevamente en unos minutos.'
          })
          
          setTimeout(() => {
            document.getElementById('modal-service-error-btn')?.click()
          }, 300);
        }
      }
    }
  }

  fnFinalize(trimmedUrl: any): void {
    if ( !this.arrServicesToExclude.includes(trimmedUrl) ) {
      this.totalRequests--
      if ( this.totalRequests === 0 ) {
        this.spinner.hide()
      }
    }
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let request = req
    request = this.fnRequest(request)

    const trimmedUrl = req.url?.split('/v1')?.[1] ?? req.url
    const trimmedUrlWithoutParams = trimmedUrl?.split('?')[0] ?? trimmedUrl;
    if ( !this.arrServicesToExclude.includes(trimmedUrlWithoutParams) ) {
      this.totalRequests++
      this.spinner.show()
    }

    //Cuando se cumplan X minutos desde la generacion inicial del token, las respuestas desde el backend van a venir con una cabecera "refreshToken"
    //Se debe agregar la configuracion en este interceptor para actualizar el token local con el valor de esa cabecera (cuando venga no vacia)
    return next.handle(request).pipe(
      tap(
        (event: HttpEvent<any>) => {
          if (event instanceof HttpResponse && event.status === 200) {
            if (event.headers.get('refreshtoken') !== undefined && event.headers.get('refreshtoken') !== null && event.headers.get('refreshtoken') !== '') {
              this._usuarios.setToken(event.headers.get('refreshtoken') ?? '')
            }
          }
        }
      ),
      catchError((err) => {
        this.fnCatchError(err, trimmedUrlWithoutParams)
        return throwError(err)
      }),
      finalize(() => {
        this.fnFinalize(trimmedUrlWithoutParams)
      })
    )
  }
}
